import { styled } from "@mui/material/styles";
import React from "react";

import { MainColumnWrapper } from "../../components/MainColumnWrapper";

type ContainerProps = { constrainWidth?: boolean; showNavigator?: boolean; children: React.ReactNode };

export function ProductFullV2Wrapper(props: ContainerProps) {
    const { constrainWidth = true, showNavigator = true, children, ...rest } = props;

    return constrainWidth ? (
        <ContainerWrapper as={MainColumnWrapper} data-is-with-navigator={showNavigator}>
            {children}
        </ContainerWrapper>
    ) : (
        <ContainerWrapper {...rest} data-is-with-navigator={showNavigator}>
            {children}
        </ContainerWrapper>
    );
}

const ContainerWrapper = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateAreas: '"gallery" "content"',
    gap: theme.spacing(2, 4),
    '&[data-is-with-navigator="true"]': {
        [theme.breakpoints.up("md")]: {
            gridTemplateAreas: '"gallery gallery" "navigation content"',
            gridTemplateColumns: "240px auto",
        },
    },
}));
